import SearchBox, { SearchIcon } from "@digits-shared/components/UI/Elements/SearchBox"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"

export const TransactionSearchBox = styled(SearchBox)`
  width: 100%;
  height: 40px;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid ${colors.secondary20};
  padding: 12px 0;

  ${SearchIcon} {
    width: 16px;
    height: 16px;
  }

  input::placeholder {
    color: ${colors.translucentSecondary40};
    ${fonts.scale.body};
    text-transform: none;
  }

  &:hover,
  &:focus {
    border-bottom-color: ${colors.secondary50};
  }
`
